module.exports = __webpack_public_path__ + "media/images/icons/filled/contacts-1a1263a32200226f9f9fee8453aff065.svg";